export default __webpack_public_path__ + "static/media/desert_day.5cd9d956.svg";